// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".organism-organization-header[data-v-80f901c4]{display:grid;grid-template:\".   .  .\" 1fr \". logo .\" 20px \".   .  .\" 1fr/1fr auto 1fr;height:100%;background-color:#fff}.organism-organization-header__logo[data-v-80f901c4]{-ms-grid-row:2;-ms-grid-column:2;grid-area:logo;align-self:center;justify-self:center;width:auto;height:100%}", ""]);
// Exports
module.exports = exports;
